import { red } from '@material-ui/core/colors';
import { createMuiTheme, Theme } from '@material-ui/core/styles';

export const theme: Theme = createMuiTheme({
    typography: {
        fontSize: 16,
        fontFamily:
            '-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,sans-serif',
    },
    palette: {
        primary: {
            main: '#ff5a60',
            dark: '#312f3d',
        },
        secondary: {
            main: '#7a7883',
            light: '#b3b8c1',
            dark: '#212529',
        },
        success: {
            main: '#64d819',
            dark: 'rgb(112, 173, 71)',
        },
        error: {
            main: red[500],
        },
        warning: {
            main: '#f57c00',
        },
    },
});
